import { Fab } from "@mui/material";
import { Wallet } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export const WalletButton = () => {
  const navigate = useNavigate();
  return (
    <Fab
      aria-label="back-to-wallet"
      color="primary"
      onClick={() => navigate("/wallet")}
      sx={{
        zIndex: 1000,
        backgroundColor: "#3f51b5",
        color: "#fff",
        fontSize: "1.2rem",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        "&:hover": {
          backgroundColor: "#303f9f",
        },
      }}
    >
      <Wallet sx={{ fontSize: "42px" }} />
    </Fab>
  );
};
